export type ValidationCategoryStatus = "PASSED" | "FAILED";

export interface ValidationCategoryResult {
  name: string;
  status: ValidationCategoryStatus;
}

export interface ValidationSummary {
  passRatePercent: number;
  unresolvedResults: number;
  categoriesCount: number;
  passedValidation: boolean;
  canPublishNow: boolean;
}

export interface ReleasePackageInfo {
  version: string;
  environment: string;
  releaseStatus: string;
}

// Dummy data matching Figma node 3687:76785 (Validate & Release workspace).
export const VALIDATION_SUMMARY: ValidationSummary = {
  passRatePercent: 100,
  unresolvedResults: 0,
  categoriesCount: 5,
  passedValidation: true,
  canPublishNow: true
};

export const VALIDATION_CATEGORIES: ValidationCategoryResult[] = [
  { name: "Schema Validation", status: "PASSED" },
  { name: "Reasoning Validation", status: "PASSED" },
  { name: "Coverage Validation", status: "PASSED" },
  { name: "Graph Integrity Validation", status: "PASSED" },
  { name: "SHACL / Rule Validation", status: "PASSED" }
];

export const RELEASE_PACKAGE_INFO: ReleasePackageInfo = {
  version: "1.0",
  environment: "OIL-GAS-PROD",
  releaseStatus: "Ready for release"
};
